/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { routerActions } from 'react-router-redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import Nvl from 'loracoms/Nvl';
import Toolbar from 'loracoms/Toolbar';
import DeleteModal from 'loracoms/DeleteModal';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';

const propTypes = {
  pushState: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  appState: PropTypes.object.isRequired,
  dash: PropTypes.object.isRequired,
};

class DetailHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appState: props.appState,
      showModal: false,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
  }

  componentWillReceiveProps(nextProps) {
    const { appState } = nextProps;
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }

  confirmDelete() {
    const { appState: { data: { id } } } = this.state;
    const { pushState, dash } = this.props;

    callAPI({
      endpoint: `/lora/dashboards/${dash.id}`,
      method: 'DELETE',
    })
      .then(() => {
        pushState(`/application/${id}/dashboard`);
      })
      .catch(() => {});
  }

  render() {
    const { pushState, dash } = this.props;
    const { showModal, appState } = this.state;
    const { status, data: { name, id } = {} } = appState;
    if (!name) {
      return null;
    }

    const rightTools = [{
      type: 'buttons',
      buttons: [(
        <Button
          bsStyle="aisz-danger"
          onClick={() => this.setState({ showModal: true })}
        >
          {this.intlMsg.msg('delete.dashboard')}&nbsp;
          <i className="fa fa-trash-o" />
        </Button>
      )],
    }];

    const breadcrumb = [
      {
        content: this.intlMsg.globalMsg('application.breadcrumb.application'),
        onClick: () => pushState('/application'),
      },
      {
        content: <Nvl status={status} val={name} />,
        onClick: () => pushState(`/application/${id}/dashboard`),
      },
      {
        content: dash.name,
        onClick: () => pushState(`/application/${id}/dashboard`),
        active: true,
      },
    ];

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Toolbar breadcrumb={breadcrumb} rightTools={rightTools} />
          </Col>
        </Row>
        <DeleteModal
          showModal={showModal}
          onConfirm={() => this.confirmDelete()}
          onCancel={() => this.setState({ showModal: false })}
          headerText={this.intlMsg.msg('delete.dashboard')}
          text={this.intlMsg.msg('delete.confirm')}
        />
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  appState: state.app.getApp,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

DetailHeader.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DetailHeader));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/DetailHeader/index.jsx